import { ChangeEvent, FormEvent, useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import {DateRangeInputError } from "modules/user_management/dcdd_user/users/state/actionType";
import { ApiError } from "components";
import DateRangeForm from "./components/DataRangeForm";
import StaticsData from "./StaticsData";
import { CommercialTotalUserDataInput, DcddTotalUserDataInput } from "modules/report/dcdd_report/state/actionType";
import { fetchCommercialTotalUserByFilter, ResetCommercialFilterData } from "../state/action";
import MembershipStaticsData from "./MembershipStaticsData";

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps;
const FilterComercailData: React.FC<Props> = ({ onFetchCommercialUserByFilter,fetchCommercialUsersByFilter, onResetData }) => {
  const [formData, setFormData] = useState<CommercialTotalUserDataInput>({
    from_date: "",
    to_date: "",

  });
  const [error, setError] = useState<DateRangeInputError>({});
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [apiError, setApiError] = useState(null);
const filterData = useSelector(
  (state: any) =>
    state.commercialTotalDataReducer?.commercialTotalUserByFilterState?.commercialTotalUserByFilter
);
  useEffect(() => {
    onResetData();
    setFormData({ from_date: "", to_date: "" });
  }, []);
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    setFormData((prevData) => {
      const newFormData = { ...prevData, [name]: value };

      let newErrors: DateRangeInputError = { ...error };

      if (newFormData.from_date && newFormData.from_date) {
        if (newFormData.from_date > newFormData.to_date) {
          newErrors.fromDate = "From date should be earlier than To date";
          newErrors.toDate = "To date should be later than From date";
        } else {
          newErrors.fromDate = "";
          newErrors.toDate = "";
        }
      } else {
        newErrors.fromDate = "";
        newErrors.toDate = "";
      }
      setError(newErrors);

      return newFormData;
    });
  };

const handleSave = async (e: FormEvent) => {
  e.preventDefault();

  const errors: DateRangeInputError = {};

  if (!formData.from_date) {
    errors.fromDate = "From date is required";
  }
  if (!formData.to_date) {
    errors.toDate = "To date is required";
  }
  if (
    formData.from_date &&
    formData.to_date &&
    formData.from_date > formData.to_date
  ) {
    errors.fromDate = "From date should be earlier than To date";
    errors.toDate = "To date should be later than From date";
  }

  setError(errors);

  if (Object.keys(errors).length !== 0) return;

  setSubmitted(true);
  setLoading(true);

  try {
    // ✅ Convert to ISO format
    const formattedData: CommercialTotalUserDataInput = {
      from_date: new Date(formData.from_date).toISOString(),
      to_date: new Date(formData.to_date).toISOString(),
    };


    await onFetchCommercialUserByFilter(formattedData);
  } catch (err) {
    console.error("Failed to fetch user:", err);
  } finally {
    setLoading(false);
  }
};

// const filterData = fetchCommercialUsersByFilter
  useEffect(() => {
    if (!fetchCommercialUsersByFilter&& submitted) {
      if (fetchCommercialUsersByFilter) {
        setApiError(fetchCommercialUsersByFilter.error);
      } else {
        setApiError(null);
      }
    }
  }, [fetchCommercialUsersByFilter, fetchCommercialUsersByFilter, submitted]);
  return (
    <>
      <div className="mx-8 mt-8">
        <h2 className="text-2xl font-medium mb-2">
          Search the commercial users by date range
        </h2>
        <DateRangeForm
          formData={formData}
          error={error}
          loading={loading}
          handleChange={handleChange}
          handleSubmit={handleSave}
        />
      </div>
      {apiError && <ApiError>{apiError}</ApiError>}
      <StaticsData commercialDcddUserData = {filterData}/>
      <MembershipStaticsData commercialDcddUserData={filterData}/>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    fetchCommercialUsersByFilter:state.commercialTotalDataReducer?.commercialTotalUserByFilterState?.commercialTotalUserByFilter

  };
};
const mapDispatchToProps = (dispatch: any) => ({
  onFetchCommercialUserByFilter: (input: CommercialTotalUserDataInput) =>
    dispatch(fetchCommercialTotalUserByFilter(input)),
   onResetData: () => dispatch(ResetCommercialFilterData()),
});
export default connect(mapStateToProps, mapDispatchToProps)(FilterComercailData);
